<section class="section section--top">
  <div class="section__inner">
    <app-index-topbar></app-index-topbar>
  </div>
</section>
<ng-content></ng-content>
<app-index-footer></app-index-footer>
